import Vue from 'vue'
import UserOccupancyModal from './index.vue'

// 兼容 Rspack ESM 模式下 .vue 文件可能被包装为命名空间对象的情况
const ModalComp = (UserOccupancyModal && UserOccupancyModal.default) || UserOccupancyModal
const Toast = Vue.extend(ModalComp)

let instance

export default {
  open(options = {}) {
    if (!instance) {
      instance = new Toast({
        el: document.createElement('div')
      })
    }
    if (instance.visible) return
    instance.userName = options.userName || ''
    instance.items = Array.isArray(options.items) ? options.items : []
    document.body.appendChild(instance.$el)
    Vue.nextTick(() => {
      instance.visible = true
    })
  },

  close() {
    if (instance) instance.visible = false
  },

  install(vue) {
    const ToastCon = vue.extend(ModalComp)
    const ins = new ToastCon()
    ins.$mount(document.createElement('div'))
    document.body.appendChild(ins.$el)
    vue.prototype.$UserOccupancyModal = obj => {
      ins.userName = (obj && obj.userName) || ''
      ins.items = obj && Array.isArray(obj.items) ? obj.items : []
      ins.visible = true
    }
  }
}